import { Button, FlexLayout, H6, Icon } from '@deity-io/portal-ui';
import NativeInputControl from 'components/FieldEditorControls/NativeInputControl';
import type { FC } from 'react';
import { useState } from 'react';

interface FreeSoloListProps {
  name: string;
  locked?: boolean;
  list: Array<string | number | boolean | null>;
  required: boolean;
  notEmpty: boolean;
  inputControlType: string;
  onChange: (key: Array<string>, value: any) => void;
}
const FreeSoloList: FC<FreeSoloListProps> = ({
  name,
  locked,
  inputControlType,
  list,
  required,
  notEmpty,
  onChange
}) => {
  /**
   * Using this reIndex count in the input key. Else with a Delete action, the controls don't match the values
   */
  const [reIndexCount, setReIndexCount] = useState(0);

  if (list && !Array.isArray(list)) {
    return <H6 color="error">Error rendering component. Input is not a list.</H6>;
  }

  const onAddOption = key => {
    onChange([key], null);
  };
  const myList = [...(list || [])];
  if (!myList.length && notEmpty) {
    myList.push(null);
  }

  return (
    <FlexLayout flexDirection="column">
      {myList.map((value, index) => (
        <FlexLayout
          justifyContent="space-between"
          // eslint-disable-next-line react/no-array-index-key
          key={`${name}_${index}`}
          alignItems="center"
          mt="xs"
          mb="xs"
          p="xs"
          flexWrap="nowrap"
        >
          <NativeInputControl
            isHeaderHidden
            // eslint-disable-next-line react/no-array-index-key
            key={`${name}_${index}_${reIndexCount}`}
            isEditable={locked !== true}
            description=""
            notEmpty
            required
            value={value == null ? undefined : value}
            property={`${index}`}
            controlType={inputControlType}
            onValueChange={(key, val) => {
              onChange([key], val);
            }}
          />
          <Icon
            icon="close"
            // eslint-disable-next-line react/no-array-index-key
            key={`${name}_${index}_Icon`}
            onClick={() => {
              if (!locked) {
                onChange([`${index}`], undefined);
                setReIndexCount(reIndexCount + 1);
              }
            }}
          />
        </FlexLayout>
      ))}
      <Button
        key={`${name}_Button`}
        disabled={locked}
        onClick={() => onAddOption(list.length)}
        endIcon={<Icon icon="add" />}
      >
        Add
      </Button>
    </FlexLayout>
  );
};

export default FreeSoloList;
